import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { Tabs } from "components/general/Tabs";
import { Tab } from "./Tab";

export class FaqRenderer extends Component {
  constructor (props) {
    super (props);
      
    this.state = {
      init: false, 
      data: [], 
      visible: {}
    };
  }

  componentDidMount () {
    this.setState({
      init: true
    });

    this.setVisibilityData();
  }
  
  componentDidUpdate (prevProps, prevState) {
    let oldData = JSON.stringify(prevProps.content),
        newData = JSON.stringify(this.props.content);
    if (oldData !== newData) this.setVisibilityData();
  }

  render () {
    const { props } = this;

    let title = null;
    if (props.hideTitle === false) {
      title = (
        <h3>{ props.title }</h3>
      );
    }

    return (
      <div>
        {title}
        <Tabs>
          {this.renderFaqTabs()}
        </Tabs>
      </div>
    );
  }

  // --------------------------------------------------------------------

  setVisibilityData = () => {
    let { content } = this.props;
    let { init } = this.state;

    let visible = {};

    for (let n = 0; n < content.length; n++) {
      let tab = content[n];

      for (let q = 0; q < tab.questions.length; q++) {
        let questionId = `${n}-${q}-${tab.questions[q]}`;

        content[n].questions[q].id = questionId;
        visible[questionId] = false;
      }
    }

    this.setState({
      init: (!init) ? true : init,
      data: content,
      visible
    });
  };

  renderFaqTabs = () => {
    let { data } = this.state;

    return data.map((item, key) => {
      return (
        <Tab key={key} label={item.name}>
          <div>
            <h3>{item.name}</h3>
            {this.renderFaqQuestions(item.questions, key)}
          </div>
        </Tab>
      );
    });
  };

  renderFaqQuestions = (questions, tabKey) => {
    let {
      visible
    } = this.state;

    return questions.map((item, key) => {
      let questionId = `${tabKey}-${key}-${questions[key].slug}`,
          _cls = [],
          _answerCls = [],
          _tempAnswer = null;
      
      if (visible[questionId] === true) {
        _cls.push("visible");
        _answerCls.push("visible");
        _tempAnswer = (
          <div className={classnames(_answerCls)} dangerouslySetInnerHTML={{__html: item.text}}/>
        );
      }

      return (
        <div className={classnames(_cls)} key={questionId}>
          <button onClick={this.toggleVisibility(questionId)}>
            <h4>{item.title}</h4>
          </button>
          {_tempAnswer}
        </div>
      );
    });
  };

  toggleVisibility = (questionId) => {
    return () => {
      let {
        visible 
      } = this.state;

      visible[questionId] = !visible[questionId];

      this.setState({
        visible
      });
    };
  };
}

FaqRenderer.defaultProps = {
  hideTitle: false
};

FaqRenderer.propTypes = {
  hideTitle: PropTypes.bool,
  title: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          slug: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired
        })
      )
    })
  ).isRequired
};
